import { SxProps, Theme } from '@mui/system';

const styles = {
  iconColor: {
    color: 'red',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
